<template>
  <div id="container" class="menu-bonus">
    <slot  hiddenCopyright></slot>
    <header>
      <h1>うちゅう</h1>
      <div id="nav">
        <MpHamburger />
      </div>
    </header>
    <main>
      <div id="stages">
        <div class="stage-row row-1st">
          <MpBonusStage
            :table="sequence.table6and7"
            :data="bonusStage.table6and7"
            starImageLv0="bonus/buttons/01-times_table-6&7/sun-silhouette.svg"
            starImageLv1="bonus/buttons/01-times_table-6&7/sun-grayscale.svg"
            starImageLv2="bonus/buttons/01-times_table-6&7/sun-colored.svg"
            buttonImage="bonus/buttons/01-times_table-6&7/button-6&7.svg"
            addtionalStarClass="star1"
          />
          <MpBonusStage
            :table="sequence.table7and8"
            :data="bonusStage.table7and8"
            starImageLv0="bonus/buttons/02-times_table-7&8/mercury-silhouette.svg"
            starImageLv1="bonus/buttons/02-times_table-7&8/mercury-grayscale.svg"
            starImageLv2="bonus/buttons/02-times_table-7&8/mercury-colored.svg"
            buttonImage="bonus/buttons/02-times_table-7&8/button-7&8.svg"
            addtionalStarClass="star2"
          />
          <MpBonusStage
            :table="sequence.table8and9"
            :data="bonusStage.table8and9"
            starImageLv0="bonus/buttons/03-times_table-8&9/venus-silhouette.svg"
            starImageLv1="bonus/buttons/03-times_table-8&9/venus-grayscale.svg"
            starImageLv2="bonus/buttons/03-times_table-8&9/venus-colored.svg"
            buttonImage="bonus/buttons/03-times_table-8&9/button-8&9.svg"
            addtionalStarClass="star3"
          />
          <MpBonusStage
            :table="sequence.table6and9"
            :data="bonusStage.table6and9"
            starImageLv0="bonus/buttons/04-times_table-6&9/earth-silhouette.svg"
            starImageLv1="bonus/buttons/04-times_table-6&9/earth-grayscale.svg"
            starImageLv2="bonus/buttons/04-times_table-6&9/earth-colored.svg"
            buttonImage="bonus/buttons/04-times_table-6&9/button-6&9.svg"
            addtionalStarClass="star4"
          />
          <MpBonusStage
            :table="sequence.table4and7"
            :data="bonusStage.table4and7"
            starImageLv0="bonus/buttons/05-times_table-4&7/moon-silhouette.svg"
            starImageLv1="bonus/buttons/05-times_table-4&7/moon-grayscale.svg"
            starImageLv2="bonus/buttons/05-times_table-4&7/moon-colored.svg"
            buttonImage="bonus/buttons/05-times_table-4&7/button-4&7.svg"
            addtionalStarClass="star5"
          />
        </div>
        <div class="stage-row row-2nd">
          <MpBonusStage
            :table="sequence.table6to8"
            :data="bonusStage.table6to8"
            starImageLv0="bonus/buttons/06-times_table-6–8/mars-silhouette.svg"
            starImageLv1="bonus/buttons/06-times_table-6–8/mars-grayscale.svg"
            starImageLv2="bonus/buttons/06-times_table-6–8/mars-colored.svg"
            buttonImage="bonus/buttons/06-times_table-6–8/button-6–8.svg"
            addtionalStarClass="star6"
          />
          <MpBonusStage
            :table="sequence.table7to9"
            :data="bonusStage.table7to9"
            starImageLv0="bonus/buttons/07-times_table-7–9/jupiter-silhouette.svg"
            starImageLv1="bonus/buttons/07-times_table-7–9/jupiter-grayscale.svg"
            starImageLv2="bonus/buttons/07-times_table-7–9/jupiter-colored.svg"
            buttonImage="bonus/buttons/07-times_table-7–9/button-7–9.svg"
            addtionalStarClass="star7"
          />
          <MpBonusStage
            :table="sequence.table2to5"
            :data="bonusStage.table2to5"
            starImageLv0="bonus/buttons/08-times_table-2–5/saturn-silhouette.svg"
            starImageLv1="bonus/buttons/08-times_table-2–5/saturn-grayscale.svg"
            starImageLv2="bonus/buttons/08-times_table-2–5/saturn-colored.svg"
            buttonImage="bonus/buttons/08-times_table-2–5/button-2–5.svg"
            addtionalStarClass="star8"
          />
          <MpBonusStage
            :table="sequence.table6to9"
            :data="bonusStage.table6to9"
            starImageLv0="bonus/buttons/09-times_table-6–9/uranus-silhouette.svg"
            starImageLv1="bonus/buttons/09-times_table-6–9/uranus-grayscale.svg"
            starImageLv2="bonus/buttons/09-times_table-6–9/uranus-colored.svg"
            buttonImage="bonus/buttons/09-times_table-6–9/button-6–9.svg"
            addtionalStarClass="star9"
          />
          <MpBonusStage
            :table="sequence.table2to9"
            :data="bonusStage.table2to9"
            starImageLv0="bonus/buttons/10-times_table-2–9/neptune-silhouette.svg"
            starImageLv1="bonus/buttons/10-times_table-2–9/neptune-grayscale.svg"
            starImageLv2="bonus/buttons/10-times_table-2–9/neptune-colored.svg"
            buttonImage="bonus/buttons/10-times_table-2–9/button-2–9.svg"
            addtionalStarClass="star10"
          />
        </div>
        <div class="btn-box">
          <img :src="$image('bonus/buttons/back.svg')" alt="" @click="doBackNormal">
        </div>
      </div>
      <img class="rocket" :src="$image('bonus/rocket.svg')" alt="">
      <MpSpeechBubble
        v-if="isShowSpeechBubble"
        class="speech_bubble"
        arrowDirection="bottom left"
        arrowPos="20%"
        @close="isShowSpeechBubble = false"
      >
        うちゅうステージクリア おめでとう！
      </MpSpeechBubble>
    </main>
    <footer>
      <MpCopyright rigid></MpCopyright>
    </footer>
  </div>
</template>

<script>
import MpHamburger from "@/components/ui/MpHamburger";
import MpBonusStage from "@/components/ui/MpBonusStage";
import Bonus from "@/mixins/bonus";
import MpCopyright from "@/components/ui/MpCopyright.vue";
import MpSpeechBubble from "../../ui/MpSpeechBubble.vue";

export default {
  components: {
    MpHamburger,
    MpBonusStage,
    MpCopyright,
    MpSpeechBubble,
  },
  mixins: [Bonus],
  data() {
    return {
      isShowSpeechBubble: false,
    };
  },
  computed: {
    isBonusStageClear() {
      return this.$store.getters["learningState/isBonusContentCompleted"];
    },
    isBonusStageClearOld() {
      return this.$store.getters["learningState/getIsBonusStageClear"];
    },
    bonusStage() {
      return this.$store.getters["learningState/getState"]?.bonus;
    },
  },
  created() {
    // 横レイアウト強制
    this.$log.debug("横レイアウト強制");
    this.$store.commit("app/enforceOrientationLandscape");
  },
  mounted() {
    // ボーナスステージ選択
    this.$store.dispatch("app/selectStage", "bonus");

    if (this.isBonusStageClear && !this.isBonusStageClearOld) {
      this.isShowSpeechBubble = true;
      this.$store.commit("learningState/setIsBonusStageClear", this.isBonusStageClear);
    }
  },
  methods: {
    // ノーマルステージ表示
    doBackNormal() {
      // 画面ボタン操作イベント
      this.$store.dispatch("history/viewButtonEvent", {
        loginId: this.$store.getters["auth/getLoginId"],
        view: this.$store.getters["app/getCurrentView"],
        event: "うみにもどる",
      });
      // 画面遷移
      this.$store.commit("app/setCurrentView", "ViewStageNormal");
    },
  },
};
</script>

<style lang="scss" scoped>
#container {
  background: var(--bg-image-bg_bonus) no-repeat bottom 100% left 0%;
  background-size: cover;

  .row-2nd {
    margin-top: 3%;
  }

  .btn-box {
    display: flex;
    justify-content: center;
    width: 100%;

    img {
      width: calc(var(--size-base) * 100);
      cursor: pointer;
    }
  }

  .rocket {
    position: absolute;
    top: 40%;
    left: 2%;
    width: calc(var(--size-base) * 100);
  }

  .speech_bubble {
    position: absolute;
    top: 26%;
    left: 8%;
  }

  footer {
    padding-left: 1.3%;
    background-color: #FFFFFF;
    height: 4.5%;
  }
}
</style>